<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="d-flex justify-center mx-6 mt-1">
      <v-col cols="12" sm="11" md="9" lg="5">
        <v-card-pro-patient-c-form
          :cardPatForm2Items="schema.cardPatForm2Items"
          :schemaForm="schema.schemaForm"
          :schemaFormNoEdit="schema.schemaFormNoEdit"
          :modelFormReg1="modelForm"
          :handleEvents="handleEvents"
          :saveForm="saveForm"
          :dialogAccountPin="schema.dialogAccountPin"
        />
      </v-col>

      <v-divider vertical class="mx-5" v-if="$vuetify.breakpoint.lgAndUp"></v-divider>

      <v-col cols="12" sm="11" md="11" lg="7" class="mt-16 mt-lg-0">
        <v-table-pro-patient-records
          :headers="schema.headersHCPRecord"
          :dataCrud="dataCrud"
          :headersHCPvsTest="schema.headersHCPvsTest"
          :dataHCPvsTest="schema.dataHCPvsTest"
          :cloneHCP="schema.cloneHCP"
          :clickTo="clickTo"
          :summaryHCP="summaryHCP"
          :exportHCP="exportHCP"
          :createHCP="createHCP"
          :selected.sync="selected"
          :checkboxFormEmpty.sync="checkboxFormEmpty"
          :handleEventsbox="handleEventsbox"
          :transfer="transfer"
          :codeTransferInput="codeTransferInput"
          :assimilate="assimilate"
          :assimilateNPatNoCount.sync="assimilateNPatNoCount"
          :assimilateNPatVerif.sync="assimilateNPatVerif"
        />
      </v-col>
    </v-row>
    <v-overlay v-model="overlayProgress" style="z-index: 1000; position: absolute">
      <v-row class="mt-13 ml-3" style="width: 200px">
        <v-col cols="12" class="ma-0 pa-0">
          <span class="d-flex text-subtitle-1 justify-center text-black">Procesando</span>
        </v-col>
        <v-col cols="12">
          <v-progress-linear class="mx-auto" indeterminate rounded height="7"></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VCardProPatientCForm from '@/components/base/VCardProPatientCForm.vue';
import VTableProPatientRecords from '@/components/base/VTableProPatientRecords.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProPatientsCPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VCardProPatientCForm,
    VTableProPatientRecords,
    VSnackBar,
  },
  data() {
    return {
      isSummaryActive: false,
      isExportActive: false,
      overlayProgress: false,
      selected: [],
      checkboxFormEmpty: false,
      assimilateNPatNoCount: '',
      assimilateNPatVerif: ''
    };
  },
  mounted() {
    this.loadData()
  },

  computed: {
    ...mapGetters('proPatientsCPage', ['schema', 'modelForm', 'dataCrud', 'status']),
    ...mapGetters('proProfileAPage', ['catDepartments', 'catProvinces', 'catDistricts']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proPatientsCPage', ['loadSchema', 'loadModelForm', 'loadDataCrud']),
    ...mapActions('proProfileAPage', [
      'loadCatDepartments',
      'loadCatProvinces',
      'loadCatDistricts',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        this.overlayProgress = true;
        await Promise.all([
          this.loadSchema(),
          this.loadCatDepartments(),
          this.loadCatProvinces(),
          this.loadCatDistricts(),
          this.loadModelForm(),
          this.loadDataCrud(),
        ]); 
        this.overlayProgress = false;  
      } catch (error) {
        this.overlayProgress = false;
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    handleEvents(val) {
      this.val = val;
      this.ubigeo();
    },

    handleEventsbox(val) {
      this.checkboxFormEmpty = val;

      if (val === true) {
        this.selected = [];
      }
    },

    ubigeo() {
      const usersCountry = this.val.data.users_birth_iso3366;

      if (!usersCountry) return;

      if (usersCountry === 'PE') {
        this.schema.schemaForm.users_birth_department.items = this.catDepartments;
      } else if (usersCountry !== 'PE') {
        this.schema.schemaForm.users_birth_department.items = [
          { departments_id: '999999', departments: '---' },
        ];
        this.modelFormbirth_department = '999999';
      }
    },

    async summaryHCP(item) {
      this.overlayProgress = true;
      this.snackbar.visible = false;
      this.snackbar.visible = true;
      this.snackbar.content = "Descargando el reporte. Puede tomar unos minutos";
      this.isSummaryActive = true;

      this.$store.dispatch('proPatientsCPage/summaryHCP', item).then(
        () => {
          this.reload();
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = "Reporte descargado";
          this.overlayProgress = false;
          this.isSummaryActive = false;
        },
        () => {
          this.reload();
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = "No se pudo descargar el reporte";
          this.overlayProgress = false;
          this.isSummaryActive = false;
        }
      );
    },

    async exportHCP(item) {
      this.overlayProgress = true;
      this.snackbar.visible = false;
      this.snackbar.visible = true;
      this.snackbar.content = "Exportando datos. Puede tomar unos minutos";
      this.isExportActive = true;

      this.$store.dispatch('proPatientsCPage/exportHCP', item).then(
        () => {
          this.reload();
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = "Datos descargados";
          this.overlayProgress = false;
          this.isExportActive = false;
        },
        () => {
          this.reload();
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = "No se pudo descargar los datos";
          this.overlayProgress = false;
          this.isExportActive = false;
        }
      );
    },

    async saveForm() {
      this.overlayProgress = true;
      const model = this.modelForm;
      model.users_birth_ubigeo = model.users_birth_district;
      this.$store.dispatch('proPatientsCPage/saveForm', model).then(
        () => {
          this.reload();
          this.snackbarOpen();
          this.overlayProgress = false;
        },
        () => {
          this.reload();
          this.snackbarOpen();
          this.overlayProgress = false;
        }
      );
    },

    codeTransferInput(codeTransfer) {
      this.codeTransfer = codeTransfer;
    },

    async transfer() {
      this.overlayProgress = true;
      let model = {};
      model.codeTransfer = this.codeTransfer;
      model.instProfesId = this.$store.state.auth.authData.institutions_profes_id;

      this.$store.dispatch('proPatientsCPage/transfer', { model }).then(
        () => {
          this.reload();
          this.snackbar.visible = false;
          if (this.status === 'success') {
            this.snackbarOpen();
          } else if (this.status === 'error') {
            this.snackbar.visible = true;
            this.snackbar.content = "Código incorrecto.";
          }
          this.overlayProgress = false;
        },
        () => {
          this.reload();
          this.snackbarOpen();
          this.overlayProgress = false;
        }
      );
    },

    async assimilate() {
      this.overlayProgress = true;
      let model = {};
      model.assimilateNPatNoCount = this.assimilateNPatNoCount;
      model.assimilateNPatVerif = this.assimilateNPatVerif;
      model.instProfesId = this.$store.state.auth.authData.institutions_profes_id;
      model.userType = "Pro";

      this.$store.dispatch('proPatientsCPage/assimilate', { model }).then(
        () => {
          this.reload();
          this.snackbar.visible = false;
          if (this.status === 'success') {
            this.snackbar.visible = true;
            this.snackbar.content = "Se envió el correo de confirmación al paciente.";
          } else if (this.status === 'error') {
            this.snackbar.visible = true;
            this.snackbar.content = "No se logró realizar la operación";
          } else if (this.status === 'denied') {
            this.snackbar.visible = true;
            this.snackbar.content = "No tiene permiso. Revisar los NPat.";
          }
          this.overlayProgress = false;
        },
        () => {
          this.reload();
          this.snackbarOpen();
          this.overlayProgress = false;
        }
      );
    },

    async createHCP() {
      this.overlayProgress = true;
      const selected = this.selected;

      let clinicalHistVersAN_id;
      if (selected.length > 0) {
        clinicalHistVersAN_id = selected[0].clinicalHistories_id;
      }

      if (this.checkboxFormEmpty === false || !this.checkboxFormEmpty) {
        if (!clinicalHistVersAN_id) {
          alert('Debe seleccionar al menos una opción antes de continuar.');
          this.overlayProgress = false;
          return;
        }
      }

      let versionAN = {
        checkboxFormEmpty: this.checkboxFormEmpty,
        clinicalHistVersAN_id: clinicalHistVersAN_id,
      }

      this.$store.dispatch('proPatientsCPage/createHCP', versionAN).then(
        () => {
          this.reload();
          this.clearAnamData();
          this.snackbarOpen();
          this.overlayProgress = false;
        },
        () => {
          this.reload();
          this.clearAnamData();
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.status;
          this.overlayProgress = false;
        }
      );
    },

    clickTo(clickItem) {
      if (this.isSummaryActive || this.isExportActive) return;
      
      if (clickItem.permission_HCP === '✔️ Acceso' || clickItem.permission_HCP === '👁️ Observador') {
        this.$store.commit('auth/setClinicalHistoriesId', clickItem.clinicalHistories_id);
        this.$router.push({ name: 'index' });
      } else {
        this.snackbar.visible = true;
        this.snackbar.content = 'No tiene acceso a esta HCP. Solicitar transferencia.';
      }
    },

    clearAnamData() {
      this.$store.commit('resetAnamData');
    },

    reload() {
      this.loadSchema();
      this.loadCatDepartments();
      this.loadCatProvinces();
      this.loadCatDistricts();
      this.loadModelForm();
      this.loadDataCrud();
    },
    
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>
